
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import utils from "@/utils";
import dayjs from "dayjs";
@Component({
  components: {
    SubHeader,
    Search,
    MenuFooter,
  },
})
export default class ListNotification extends Vue {
  mounted() {
    this.getDetailTicket(this.$route.params.id);
  }
  dayjs = dayjs;
  utils = utils;
  titlePage = "Detail Ticket";
  date = "21/JAN/2022";
  time = "12.30";
  title = "Cake Engine Breaking Down";
  subTitle = "Lorem Ipsum is simply text";
  status = "new";
  isOpen = "0";

  ticket: TicketModel = new TicketModel();

  history = [
    {
      title:"Ticket Open",
      pic:"Miing"
    },
    {
      title:"In Progress",
      pic:"Midun"
    },
    {
      title:"Waiting for user feedback",
      pic:"Juki"
    },
    {
      title:"Waiting for Report Review",
      pic:"SPC"
    },
    {
      title:"Technical Completion (Closed)",
      pic:"Miing"
    },
  ]
  getDetailTicket(idTicket: string) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getDetailTicket2(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.ticket = Object.assign({}, response.data.data);
            // console.log(this.ticket);
            resolve(response);
          }
        })
        .catch((err: any) => {
          reject(err);
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    });
  }
  get colorStatus() {
    if (this.ticket.tiket_status === "new") {
      return "cl-red";
    } else {
      return "cl-green-light";
    }
  }
  get pitaStatus() {
    if (this.ticket.tiket_status === "new") {
      return "new";
    } else {
      return "on-progress";
    }
  }
}
